import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import service from '../../../apis/service';
import { apiEndpoints } from '../../../constants/apiEndpoints';
import { ErrorToast } from '../../utils/Utils';
import { showProgress } from '../../../redux/actions/DealershipActions';

const useFetchData = () => {
  const dispatch = useDispatch();
  const [dealershipList, setDealershipList] = useState([]);
  const [deptList, setDeptList] = useState([]);
  const [rolesList, setRolesList] = useState([]);
  const [zombieList, setZombieList] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const getRoles = async (id) => {
    dispatch(showProgress(true));
    await service
      .get(apiEndpoints.DEALER_ROLES.replace('ID', id), '')
      .then((res) => {
        res.sort((a, b) => a.id - b.id);
        setRolesList([...res]);
        dispatch(showProgress(false));
      })
      .catch(() => {
        dispatch(showProgress(false));
      });
  };
  const getData = useCallback(async () => {
    dispatch(showProgress(true));
    try {
      const p1 = service.get(apiEndpoints.GET_DEALERSHIPS);
      const p2 = service.get(apiEndpoints.GET_DEPARTMENTS);
      const responses = await Promise.all([p1, p2]);
      setDealershipList(responses[0]);
      setDeptList(responses[1]);
    } catch (err) {
      ErrorToast(err);
    } finally {
      dispatch(showProgress(false));
    }
  }, [dispatch]);
  const getList = useCallback(
    async (pagination = null, sorting = null, globalFilter = '') => {
      const sort = sorting ? sorting[0] : {};
      const payload = {
        pageIndex: pagination?.pageIndex || 0,
        pageSize: pagination?.pageSize || 10,
        sortBy: sort?.id || 'id',
        orderBy: sort?.desc ? 'DESC' : 'ASC',
        search: globalFilter ?? '',
      };
      dispatch(showProgress(true));
      try {
        const response = await service.post(apiEndpoints.DEV_FETCH_ZOMBIE_LIST, payload);
        setZombieList(response?.employees);
        setRowCount(response?.totalCount);
      } catch (error) {
        console.error('Error fetching logs data', error);
      } finally {
        dispatch(showProgress(false));
      }
    },
    [dispatch],
  );

  useEffect(() => {
    getData();
  }, [getData]);
  return { dealershipList, deptList, getRoles, rolesList, getData, getList, zombieList, rowCount };
};

export default useFetchData;
